import React from 'react';
import Modal from '../Modal/modal';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';

const RejectReasonModal = ({
  showRejectModal,
  setShowRejectModal,
  rejectReasonMsg,
  setRejectResonMsg,
  isError,
  errorMessage,
  rejectDocFun,
  docId,
  text,
  title = 'Reject Application',
  onFocus,
  onBlur
}) => {
  return (
    <div>
      <Modal
        show={showRejectModal}
        setShow={setShowRejectModal}
        styleContainer={{
          minWidth: '300px'
        }}
        noCloseBtn={true}
        title={title}
        titleStyle={{ color: '#2d3748', fontSize: '17px', fontWeight: '400' }}
      >
        <div className="w-full text-center">
          <hr className="border-grey-400 -mt-1 mb-5" />
          <div className="mb-5 mt-2">
            <CancelRoundedIcon style={{ color: 'red', fontSize: '60px' }} />
          </div>
          <p className="font-roboto text-sm text-black-1013 text-left">
            {text ? text : ' Do you want to reject the application ?'}
          </p>
          <p className="font-roboto text-sm text-black-1013 text-left mt-4">
            Please give a reason.
          </p>
          <textarea
            name="message_block"
            placeholder="write here..."
            value={rejectReasonMsg}
            className={`w-full mt-1 border  rounded px-3 py-4 ${
              isError ? 'border-red-500' : 'border-grey-400'
            }`}
            style={{ minHeight: '100px' }}
            onChange={e => setRejectResonMsg(e.target.value)}
            onFocus={() => typeof onFocus == 'function' && onFocus()}
            onBlur={() => typeof onBlur == 'function' && onBlur()}
          ></textarea>
          <p className="text-sm text-left px-1  font-roboto font-normal text-red-500">
            {isError ? errorMessage : null}
          </p>
          <div className="w-full flex mb-4 mt-7">
            <button
              type="button"
              className="  py-2 text-white bg-red-500 rounded text-base px-6 ml-auto"
              onClick={() => {
                if (!isError) {
                  rejectDocFun(docId, rejectReasonMsg);
                }
              }}
            >
              Reject
            </button>
            <button
              type="button"
              className={`px-6 ml-2  py-2 text-white bg-green-900 rounded text-base`}
              onClick={() => setShowRejectModal(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default RejectReasonModal;
